import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createTaskAction } from '../../../redux/actions/tasksActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import TaskForm from '../forms/TaskForm';

const CreateTaskModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createTaskAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати послугу'}
      loading={loading}
      onClose={onModalClose}
      body={<TaskForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'task-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateTaskModal;
